import type { ContentHref, Version } from '@generalTypes/apiTypes';
import { versionsApi } from '@store/api/apiConfig';

export const getVersionsForContent = (contentHref: ContentHref): Promise<Version[]> => {
  return versionsApi.getAll('/versions', { resource: contentHref });
};
